import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { TopDeskDetailsTileModel, updateTopDeskTile } from "client/Api/Workspace/workspace";

export type EditTopDeskTileProps = EditGenericWithDestinationWindowTilePropsBase<TopDeskDetailsTileModel>;

export const EditTopDeskTile = forwardRef(
	(props: EditTopDeskTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateTopDeskTile}
				ref={ref}
			/>
		);
	}
);
EditTopDeskTile.displayName = "EditTopDeskTile";
